/* Chiemseegarn-Menü (cg-nav): Desktop-Mega-Menü mit Hover-Absicht + Mobil-Drawer.
   Lesbare Quelle: Claude Projects/Chiemseegarn/theme-menue-2026/ */
(() => {
  if (window.__cgNavInit) return;
  window.__cgNavInit = true;

  const DESKTOP_MIN = 1280; // darunter Drawer statt Leiste
  const OPEN_DELAY = 70; // Hover bis zum ersten Öffnen
  const SWITCH_DELAY = 160; // Verweilen nötig, um auf anderen Punkt zu wechseln (diagonale Wege)
  const CLOSE_DELAY = 320; // Gnadenfrist beim Verlassen

  const isTouch = () => 'ontouchstart' in window && navigator.maxTouchPoints > 0;
  const header = () => document.querySelector('#header-component');

  /* ---------- Menüstil (Leiste vs. Drawer) ---------- */
  function applyMenuStyle() {
    const h = header();
    if (!h || !h.querySelector('[data-cg-nav], [data-cg-burger]')) return;
    const want = isTouch() || window.innerWidth < DESKTOP_MIN ? 'drawer' : 'menu';
    if (h.dataset.menuStyle !== want) h.dataset.menuStyle = want;
  }

  /* ---------- Desktop ---------- */
  let scrim = null;
  let closeOpenPanel = () => {};

  function getScrim() {
    if (!scrim || !scrim.isConnected) {
      scrim = document.querySelector('.cg-nav-scrim') || document.createElement('div');
      scrim.className = 'cg-nav-scrim';
      if (!scrim.isConnected) document.body.appendChild(scrim);
      scrim.addEventListener('click', () => closeOpenPanel());
      scrim.addEventListener('pointerenter', (e) => {
        if (e.pointerType === 'mouse') closeOpenPanel(true);
      });
    }
    return scrim;
  }

  function initDesktop(nav) {
    if (nav.dataset.cgReady) return;
    nav.dataset.cgReady = '1';

    const items = [...nav.querySelectorAll('[data-cg-item]')];
    let openItem = null;
    let openTimer = 0;
    let closeTimer = 0;
    let warmed = false;

    const panelOf = (item) => item.querySelector('[data-cg-panel]');
    const triggerOf = (item) => item.querySelector('[data-cg-trigger]');

    function setTop() {
      const row = nav.closest('.header__row') || header() || nav;
      const bottom = Math.max(0, Math.round(row.getBoundingClientRect().bottom));
      document.documentElement.style.setProperty('--cgn-panel-top', bottom + 'px');
    }

    function warm() {
      if (warmed) return;
      warmed = true;
      nav.querySelectorAll('[data-cg-panel] img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
    }

    function hide(item) {
      panelOf(item)?.classList.remove('is-open');
      triggerOf(item)?.setAttribute('aria-expanded', 'false');
    }

    function close() {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      if (openItem) hide(openItem);
      openItem = null;
      getScrim().classList.remove('is-visible');
    }

    function scheduleClose(delay = CLOSE_DELAY) {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(close, delay);
    }

    function open(item) {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      if (openItem === item) return;
      if (openItem) hide(openItem);
      const panel = panelOf(item);
      if (!panel) return close();
      setTop();
      panel.classList.add('is-open');
      triggerOf(item)?.setAttribute('aria-expanded', 'true');
      getScrim().classList.add('is-visible');
      openItem = item;
      closeOpenPanel = (delayed) => (delayed ? scheduleClose() : close());
    }

    // Bilder vorladen, sobald die Maus den Header betritt (nicht bei jedem Seitenaufruf)
    (nav.closest('.header__row') || nav).addEventListener('pointerenter', (e) => {
      if (e.pointerType === 'mouse') warm();
    });
    nav.addEventListener('focusin', warm);

    items.forEach((item) => {
      const hasPanel = !!panelOf(item);
      const trigger = item.querySelector('.cg-nav__top');

      item.addEventListener('pointerenter', (e) => {
        if (e.pointerType !== 'mouse') return;
        warm();
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        if (openItem === item) return;
        if (!hasPanel) {
          // Punkt ohne Panel: offenes Panel erst nach Verweilen schließen (Durchfahren erlaubt)
          if (openItem) openTimer = setTimeout(close, SWITCH_DELAY);
          return;
        }
        openTimer = setTimeout(() => open(item), openItem ? SWITCH_DELAY : OPEN_DELAY);
      });

      item.addEventListener('pointerleave', (e) => {
        if (e.pointerType === 'mouse') clearTimeout(openTimer);
      });

      if (hasPanel && trigger) {
        // Touch auf breiten Geräten: erster Tipp öffnet, zweiter folgt dem Link
        trigger.addEventListener('click', (e) => {
          const href = trigger.getAttribute('href');
          if (!href || href === '#') {
            e.preventDefault();
            openItem === item ? close() : open(item);
            return;
          }
          if ((e.pointerType === 'touch' || e.pointerType === 'pen') && openItem !== item) {
            e.preventDefault();
            open(item);
          }
        });

        trigger.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown' || e.key === ' ' || (e.key === 'Enter' && trigger.getAttribute('href') === '#')) {
            e.preventDefault();
            open(item);
            panelOf(item)?.querySelector('a')?.focus();
          }
        });
      }

      item.addEventListener('focusout', (e) => {
        if (openItem === item && !nav.contains(e.relatedTarget)) close();
      });
    });

    nav.addEventListener('pointerleave', (e) => {
      if (e.pointerType === 'mouse' && openItem) scheduleClose();
    });

    nav.addEventListener('pointerenter', (e) => {
      if (e.pointerType === 'mouse') clearTimeout(closeTimer);
    });

    nav.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && openItem) {
        const t = triggerOf(openItem);
        close();
        t?.focus();
      }
    });

    window.addEventListener('scroll', () => openItem && setTop(), { passive: true });
    document.addEventListener('click', (e) => {
      if (openItem && !nav.contains(e.target)) close();
    });
  }

  /* ---------- Drawer ---------- */
  let drawer = null;
  let lastBurger = null;

  function hash(str) {
    let h = 0;
    for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) | 0;
    return String(h);
  }

  function syncDrawer() {
    const tpl = document.querySelector('template[data-cg-drawer-tpl]');
    if (!tpl) return;
    const key = hash(tpl.innerHTML);
    const existing = document.querySelector('body > [data-cg-drawer]');
    if (existing && existing.dataset.cgKey === key) {
      drawer = existing;
      return;
    }
    const wasOpen = existing && !existing.hidden;
    existing?.remove();
    const el = tpl.content.firstElementChild.cloneNode(true);
    el.dataset.cgKey = key;
    document.body.appendChild(el);
    setupDrawer(el);
    drawer = el;
    if (wasOpen) openDrawer();
  }

  function setupDrawer(d) {
    const views = [...d.querySelectorAll('[data-cg-view]')];
    const root = d.querySelector('[data-cg-view="root"]');
    const back = d.querySelector('[data-cg-back]');
    const title = d.querySelector('[data-cg-title]');
    let stack = [root];

    const eager = (el) => el.querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
    d._cgEager = () => eager(root);

    function forward(view) {
      const current = stack[stack.length - 1];
      eager(view);
      view.hidden = false;
      view.classList.remove('is-left');
      view.classList.add('is-right');
      view.scrollTop = 0;
      stack.push(view);
      requestAnimationFrame(() =>
        requestAnimationFrame(() => {
          view.classList.remove('is-right');
          view.classList.add('is-active');
          current.classList.add('is-left');
          current.classList.remove('is-active');
        })
      );
      setTimeout(() => {
        if (stack[stack.length - 1] === view) current.hidden = true;
      }, 300);
      back.hidden = false;
      title.textContent = view.dataset.title || 'Menü';
    }

    function backward() {
      if (stack.length <= 1) return;
      const current = stack.pop();
      const prev = stack[stack.length - 1];
      prev.hidden = false;
      requestAnimationFrame(() =>
        requestAnimationFrame(() => {
          current.classList.add('is-right');
          current.classList.remove('is-active');
          prev.classList.remove('is-left');
          prev.classList.add('is-active');
        })
      );
      setTimeout(() => {
        if (!stack.includes(current)) {
          current.hidden = true;
          current.classList.remove('is-right');
        }
      }, 300);
      back.hidden = stack.length <= 1;
      title.textContent = prev.dataset.title || 'Menü';
    }

    d._cgReset = () => {
      views.forEach((v) => {
        v.classList.remove('is-left', 'is-right', 'is-active');
        v.hidden = v !== root;
      });
      root.classList.add('is-active');
      stack = [root];
      back.hidden = true;
      title.textContent = 'Menü';
    };

    d.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-cg-open]');
      if (opener) {
        const view = d.querySelector(`[data-cg-view="${opener.dataset.cgOpen}"]`);
        if (view) forward(view);
        return;
      }
      if (e.target.closest('[data-cg-back]')) return backward();
      if (e.target.closest('[data-cg-close]')) return closeDrawer();
    });

    d.addEventListener('change', (e) => {
      if (e.target.matches('[data-cg-autosubmit]')) e.target.form?.submit();
    });

    // Fokus im Drawer halten
    d.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;
      const f = [...d.querySelectorAll('a[href], button, input:not([type=hidden]), select')].filter(
        (el) => el.offsetParent !== null && !el.hidden
      );
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) {
        e.preventDefault();
        f[f.length - 1].focus();
      } else if (!e.shiftKey && document.activeElement === f[f.length - 1]) {
        e.preventDefault();
        f[0].focus();
      }
    });
  }

  function setBurgers(expanded) {
    document.querySelectorAll('[data-cg-burger]').forEach((b) => b.setAttribute('aria-expanded', String(expanded)));
  }

  function openDrawer(fromBtn) {
    syncDrawer();
    if (!drawer) return;
    if (fromBtn) lastBurger = fromBtn;
    drawer._cgReset?.();
    drawer._cgEager?.();
    drawer.hidden = false;
    document.documentElement.classList.add('cg-drawer-lock');
    requestAnimationFrame(() => requestAnimationFrame(() => drawer.classList.add('is-open')));
    setBurgers(true);
    setTimeout(() => drawer.querySelector('.cg-drawer__close')?.focus({ preventScroll: true }), 60);
    const d = drawer;
    (window.requestIdleCallback || ((fn) => setTimeout(fn, 400)))(() =>
      d.querySelectorAll('[data-cg-view] img[loading="lazy"]').forEach((img) => (img.loading = 'eager'))
    );
  }

  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    const d = drawer;
    d.classList.remove('is-open');
    document.documentElement.classList.remove('cg-drawer-lock');
    setBurgers(false);
    setTimeout(() => {
      if (!d.classList.contains('is-open')) d.hidden = true;
    }, 320);
    if (lastBurger?.isConnected) lastBurger.focus({ preventScroll: true });
  }

  // Burger per Delegation: übersteht jedes Neu-Rendern des Headers
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-cg-burger]');
    if (b) {
      e.preventDefault();
      openDrawer(b);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer && !drawer.hidden) closeDrawer();
  });

  window.addEventListener(
    'resize',
    () => {
      applyMenuStyle();
      if (drawer && !drawer.hidden && header()?.dataset.menuStyle === 'menu') closeDrawer();
    },
    { passive: true }
  );

  /* ---------- Start + Neu-Hydrierung des Headers ---------- */
  function init() {
    document.querySelectorAll('[data-cg-nav]').forEach(initDesktop);
    syncDrawer();
    applyMenuStyle();
  }

  let observed = null;
  let pending = false;
  function observeHeader() {
    const h = header();
    if (!h || h === observed) return;
    observed = h;
    new MutationObserver(() => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => {
        pending = false;
        init();
      });
    }).observe(h, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-menu-style'] });
  }

  function start() {
    init();
    observeHeader();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // Theme-Editor: Header-Section wird neu geladen
  document.addEventListener('shopify:section:load', () => requestAnimationFrame(start));
})();
